/**
 * Collection / tag filters use path URLs (/collections/all/vibe+jungle).
 * Update the grid via section AJAX so the open dropdown never closes.
 */
(function () {
  var parser = new DOMParser();
  var abortController = null;

  function isPathFilterInput(target) {
    return (
      target instanceof HTMLInputElement &&
      target.matches('input[data-collection-filter-url]')
    );
  }

  function sectionId() {
    return (
      document.getElementById('product-grid')?.dataset?.id ||
      document.querySelector('#main-collection-filters')?.dataset?.id ||
      ''
    );
  }

  function sectionFetchUrl(pageUrl) {
    var id = sectionId();
    var url = new URL(pageUrl, window.location.origin);
    if (id) url.searchParams.set('section_id', id);
    return url.toString();
  }

  function setLoading(isLoading) {
    var collection = document.querySelector('#ProductGridContainer .collection');
    if (collection) collection.classList.toggle('loading', isLoading);

    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      el.classList.toggle('loading', isLoading);
    });

    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(
      function (spinner) {
        spinner.classList.toggle('hidden', !isLoading);
      }
    );
  }

  function syncPathFilterInputs(doc) {
    doc.querySelectorAll('input[data-collection-filter-url]').forEach(function (src) {
      var dest = document.getElementById(src.id);
      if (!dest) return;
      dest.checked = src.checked;
      dest.setAttribute('data-collection-filter-url', src.getAttribute('data-collection-filter-url') || '');
      var label = dest.closest('label');
      if (label) label.classList.toggle('active', src.checked);
    });
  }

  function syncPathFilterChrome(doc) {
    doc.querySelectorAll('details.js-filter').forEach(function (srcDetails) {
      var index = srcDetails.getAttribute('data-index') || '';
      if (
        index !== 'collection' &&
        index !== 'tag' &&
        index !== 'mobile-collection' &&
        index !== 'mobile-tag'
      ) {
        return;
      }

      var destDetails = document.getElementById(srcDetails.id);
      // Mood/Collection may have been removed by Dawn facets.js — put it back
      if (!destDetails) {
        var parentId = srcDetails.parentElement && srcDetails.parentElement.id;
        var parent = parentId ? document.getElementById(parentId) : null;
        if (!parent) {
          parent =
            index.indexOf('mobile') === 0
              ? document.querySelector('#FacetFiltersFormMobile .mobile-facets__main')
              : document.getElementById('FacetsWrapperDesktop');
        }
        if (!parent) return;
        destDetails = srcDetails.cloneNode(true);
        var after = parent.querySelector('details.js-filter[data-index="collection"], details.js-filter[data-index="mobile-collection"]');
        if (after && (index === 'tag' || index === 'mobile-tag')) {
          after.after(destDetails);
        } else {
          parent.appendChild(destDetails);
        }
        return;
      }

      var wasOpen = destDetails.hasAttribute('open');
      // Don't wipe Mood options if the server returned an empty list
      // (AND-filtered responses can briefly omit tags).
      var srcList = srcDetails.querySelector('.facets__list, .mobile-facets__list, .facets__list--vertical');
      var destList = destDetails.querySelector('.facets__list, .mobile-facets__list, .facets__list--vertical');
      var srcHasOptions =
        srcList && srcList.querySelectorAll('input[data-collection-filter-url]').length > 0;
      var destHasOptions =
        destList && destList.querySelectorAll('input[data-collection-filter-url]').length > 0;
      if (!srcHasOptions && destHasOptions && (index === 'tag' || index === 'mobile-tag')) {
        var srcSummary = srcDetails.querySelector('.facets__summary-label, .mobile-facets__summary > div');
        var destSummary = destDetails.querySelector('.facets__summary-label, .mobile-facets__summary > div');
        if (srcSummary && destSummary) destSummary.innerHTML = srcSummary.innerHTML;
        var srcHeader = srcDetails.querySelector('.facets__header');
        var destHeader = destDetails.querySelector('.facets__header');
        if (srcHeader && destHeader) destHeader.innerHTML = srcHeader.innerHTML;
      } else {
        destDetails.innerHTML = srcDetails.innerHTML;
      }
      if (wasOpen) {
        destDetails.setAttribute('open', '');
        // Submenus need .menu-opening (Dawn) — reinstate after innerHTML swap
        if (index.indexOf('mobile') === 0) {
          destDetails.classList.add('menu-opening');
          var parentMenu = destDetails.closest('.has-submenu');
          if (parentMenu) parentMenu.classList.add('submenu-open');
          var summary = destDetails.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  function syncOtherFilters(doc, openDetailsId) {
    doc
      .querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      )
      .forEach(function (srcFilter) {
        var index = srcFilter.getAttribute('data-index') || '';
        if (
          index === 'collection' ||
          index === 'tag' ||
          index === 'mobile-collection' ||
          index === 'mobile-tag'
        ) {
          return;
        }
        if (srcFilter.id === openDetailsId) return;

        var dest = document.getElementById(srcFilter.id);
        if (!dest || dest.hasAttribute('open')) return;
        dest.innerHTML = srcFilter.innerHTML;
      });
  }

  function syncActiveFacets(doc) {
    var shouldReopenMore = reopenMoreTooltipAfterSync;
    var reopenTipId = reopenMoreTooltipId;
    reopenMoreTooltipAfterSync = false;
    reopenMoreTooltipId = '';

    // Drop any portaled node — section HTML replace recreates pills
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    if (portaledTooltip) {
      portaledTooltip.remove();
      portaledTooltip = null;
      portaledTrigger = null;
    }
    document.querySelectorAll('[data-active-facets-more].is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    });

    ['.active-facets-desktop', '.active-facets-mobile'].forEach(function (selector) {
      var src = doc.querySelector(selector);
      var dest = document.querySelector(selector);
      if (!src || !dest) return;
      // Keep runtime classes (e.g. is-open); only sync empty state from server HTML
      dest.innerHTML = src.innerHTML;
      dest.classList.toggle('active-facets--empty', src.classList.contains('active-facets--empty'));
    });

    if (shouldReopenMore) {
      var trigger = findMoreTriggerByTipId(reopenTipId);
      if (trigger) openMoreTooltip(trigger);
    }
  }

  function findMoreTriggerByTipId(tipId) {
    if (tipId) {
      var byControls = document.querySelector(
        '[data-active-facets-more][aria-controls="' + tipId + '"]'
      );
      if (byControls) return byControls;

      if (tipId.indexOf('Collection') !== -1) {
        var collectionMore = document.querySelector(
          '[data-active-facets-more][aria-controls^="ActiveFacetsCollectionMore"]'
        );
        if (collectionMore) return collectionMore;
      }
      if (tipId.indexOf('Tag') !== -1) {
        var tagMore = document.querySelector(
          '[data-active-facets-more][aria-controls^="ActiveFacetsTagMore"]'
        );
        if (tagMore) return tagMore;
      }
    }
    return document.querySelector('[data-active-facets-more]');
  }

  function countSelectedFilters() {
    var count = 0;
    // Desktop only — mobile mirrors the same path filters
    document
      .querySelectorAll('#FacetFiltersForm input[data-collection-filter-url]:checked')
      .forEach(function () {
        count += 1;
      });
    document
      .querySelectorAll(
        '#FacetFiltersForm .js-filter:not([data-index="collection"]):not([data-index="tag"]) input[type="checkbox"]:checked'
      )
      .forEach(function (input) {
        if (input.name && input.name.indexOf('availability') !== -1) return;
        count += 1;
      });

    // Fallback: sum group counts (covers overflow +N chips) or visible pills
    if (count === 0) {
      var root = document.querySelector('[data-ac-active-facets]');
      if (root) {
        root.querySelectorAll('[data-active-count]').forEach(function (group) {
          count += parseInt(group.getAttribute('data-active-count'), 10) || 0;
        });
        if (count === 0) {
          count = root.querySelectorAll(
            '.active-facets__tags a.active-facets__chip, .active-facets__tags a.active-facets__button'
          ).length;
        }
      }
    }
    return count;
  }

  var moreCloseTimer = null;
  var lastPointer = { x: 0, y: 0 };
  var portaledTooltip = null;
  var portaledTrigger = null;
  var reopenMoreTooltipAfterSync = false;
  var reopenMoreTooltipId = '';

  function restorePortaledTooltip() {
    if (!portaledTooltip) return;
    portaledTooltip.classList.remove('is-portaled');
    portaledTooltip.removeAttribute('style');
    if (portaledTrigger && portaledTrigger.isConnected) {
      portaledTrigger.appendChild(portaledTooltip);
    } else {
      portaledTooltip.remove();
    }
    portaledTooltip = null;
    portaledTrigger = null;
  }

  function positionPortaledTooltip(trigger, tip) {
    var PAD = 8;
    var GAP = 6;
    var rect = trigger.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    tip.classList.add('is-portaled');
    tip.style.position = 'fixed';
    tip.style.right = 'auto';
    tip.style.bottom = 'auto';
    tip.style.transform = 'none';
    tip.style.left = '0px';
    tip.style.top = '0px';
    tip.style.padding = '0';

    var tipRect = tip.getBoundingClientRect();
    var tipW = tipRect.width;
    var tipH = tipRect.height;

    // Vertical: prefer above; flip below when there isn't room
    var spaceAbove = rect.top - PAD;
    var spaceBelow = vh - rect.bottom - PAD;
    var placeAbove = !(spaceAbove < tipH + GAP && spaceBelow > spaceAbove);

    var top;
    if (placeAbove) {
      top = Math.round(rect.top - tipH - GAP);
      if (top < PAD) top = PAD;
      tip.style.padding = '0 0 0.85rem';
    } else {
      top = Math.round(rect.bottom + GAP);
      if (top + tipH > vh - PAD) top = Math.max(PAD, vh - PAD - tipH);
      tip.style.padding = '0.85rem 0 0';
    }

    // Horizontal: prefer center; pin to tag start/end near screen edges
    var tipLeft = rect.left + rect.width / 2 - tipW / 2;
    if (tipLeft < PAD) {
      tipLeft = rect.left;
    } else if (tipLeft + tipW > vw - PAD) {
      tipLeft = rect.right - tipW;
    }
    tipLeft = Math.min(Math.max(tipLeft, PAD), Math.max(PAD, vw - PAD - tipW));

    tip.style.left = Math.round(tipLeft) + 'px';
    tip.style.top = Math.round(top) + 'px';
  }

  function portalMoreTooltip(trigger) {
    var tip =
      (portaledTrigger === trigger && portaledTooltip) ||
      trigger.querySelector('.active-facets__more-tooltip');
    if (!tip) return;
    if (portaledTooltip && portaledTooltip !== tip) restorePortaledTooltip();
    portaledTooltip = tip;
    portaledTrigger = trigger;
    if (tip.parentElement !== document.body) {
      document.body.appendChild(tip);
    }
    positionPortaledTooltip(trigger, tip);
  }

  function closeAllMoreTooltips(except) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    document.querySelectorAll('[data-active-facets-more].is-open').forEach(function (el) {
      if (except && el === except) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    });
    if (!except || portaledTrigger !== except) restorePortaledTooltip();
  }

  function openMoreTooltip(trigger) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = null;
    closeAllMoreTooltips(trigger);
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    portalMoreTooltip(trigger);
  }

  function isPointerOverMore(trigger) {
    if (!trigger || !trigger.isConnected) return false;
    var el = document.elementFromPoint(lastPointer.x, lastPointer.y);
    while (el) {
      if (el === trigger) return true;
      if (portaledTooltip && el === portaledTooltip) return true;
      if (portaledTooltip && portaledTooltip.contains(el) && portaledTrigger === trigger) return true;
      if (el.classList && el.classList.contains('active-facets__more-tooltip') && trigger.contains(el)) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function scheduleCloseMoreTooltip(trigger) {
    clearTimeout(moreCloseTimer);
    moreCloseTimer = setTimeout(function () {
      moreCloseTimer = null;
      if (!trigger.isConnected) return;
      if (isPointerOverMore(trigger)) return;
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (portaledTrigger === trigger) restorePortaledTooltip();
    }, 200);
  }

  function toggleMoreTooltip(trigger) {
    if (trigger.classList.contains('is-open')) {
      closeAllMoreTooltips();
    } else {
      openMoreTooltip(trigger);
    }
  }

  function canHoverOpenMore() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function refreshFacetStatus() {
    var count = countSelectedFilters();
    var roots = document.querySelectorAll(
      '[data-ac-active-facets], .active-facets-desktop, .active-facets-mobile'
    );
    roots.forEach(function (root) {
      root.classList.toggle('active-facets--empty', count === 0);
    });

    var statusRoot =
      document.querySelector('[data-ac-active-facets]') ||
      document.querySelector('.active-facets-desktop');
    if (!statusRoot) return;
    var status = statusRoot.querySelector('[data-ac-facet-status]');
    if (!status) return;

    var label;
    if (count === 0) {
      label = status.getAttribute('data-label-all') || 'Showing all products';
    } else if (count === 1) {
      label = (status.getAttribute('data-label-one') || 'Showing COUNT selection:').replace(
        /COUNT|\{\{\s*count\s*\}\}/g,
        String(count)
      );
    } else {
      label = (status.getAttribute('data-label-other') || 'Showing COUNT selections:').replace(
        /COUNT|\{\{\s*count\s*\}\}/g,
        String(count)
      );
    }
    status.textContent = label;
  }

  function syncProductCount(doc) {
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var src = doc.getElementById(id);
      var dest = document.getElementById(id);
      if (!src || !dest) return;
      dest.innerHTML = src.innerHTML;
      dest.dataset.productCount = src.dataset.productCount || '';
      dest.dataset.totalCount = src.dataset.totalCount || '';
      dest.classList.remove('loading');
    });

    // Mobile drawer header count (no stable id)
    var srcMobile = doc.querySelector('.mobile-facets__count');
    document.querySelectorAll('.mobile-facets__count').forEach(function (dest) {
      if (!srcMobile) return;
      dest.innerHTML = srcMobile.innerHTML;
    });
  }

  function finishApplySection(doc, openDetailsId) {
    syncProductCount(doc);
    syncPathFilterChrome(doc);
    syncPathFilterInputs(doc);
    syncOtherFilters(doc, openDetailsId);
    syncActiveFacets(doc);
    // Status after inputs + pills are in sync (never overwrite server HTML with a stale count)
    refreshFacetStatus();

    document.dispatchEvent(new CustomEvent('ac:product-tags:refit'));
    if (typeof window.acFitProductTags === 'function') window.acFitProductTags();

    if (openDetailsId) {
      var openDetails = document.getElementById(openDetailsId);
      if (openDetails) {
        openDetails.setAttribute('open', '');
        if (openDetails.classList.contains('mobile-facets__details')) {
          openDetails.classList.add('menu-opening');
          var parentMenu = openDetails.closest('.has-submenu');
          if (parentMenu) parentMenu.classList.add('submenu-open');
          var summary = openDetails.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }
    }

    // Rebind drawer after path-filter innerHTML swaps replace summary/close buttons
    document.querySelectorAll('menu-drawer.mobile-facets__wrapper').forEach(function (drawer) {
      if (typeof drawer.bindEvents === 'function') drawer.bindEvents();
    });

    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(
      function (spinner) {
        spinner.classList.add('hidden');
      }
    );

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.filterData = [];
    }
  }

  function applySectionHtml(html, openDetailsId) {
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = doc.getElementById('ProductGridContainer');
    var grid = document.getElementById('ProductGridContainer');

    // Instant swap — skip acSoftGridSwap fade-out/enter (that stacked with
    // .collection.loading and made the grid blink: dim → flash → rise from 0).
    if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
    setLoading(false);
    finishApplySection(doc, openDetailsId);
  }

  function syncKindSwitchHrefs(pageUrl) {
    var next = new URL(pageUrl, window.location.origin);
    document.querySelectorAll('[data-ac-kind-switch] .ac-kind-switch__option').forEach(function (option) {
      var current = new URL(option.getAttribute('href') || next.pathname, window.location.origin);
      var view = current.searchParams.get('view');
      var href = next.pathname;
      if (view === 'cases' || view === 'powerbanks') href += '?view=' + view;
      option.setAttribute('href', href);
    });
  }

  function preserveProductKind(pageUrl) {
    var currentKind = new URL(window.location.href).searchParams.get('view');
    if (currentKind !== 'cases' && currentKind !== 'powerbanks') return pageUrl;
    var next = new URL(pageUrl, window.location.origin);
    if (!next.searchParams.has('view')) next.searchParams.set('view', currentKind);
    return next.pathname + next.search + next.hash;
  }

  function loadPathFilter(pageUrl, openDetailsId) {
    pageUrl = preserveProductKind(pageUrl);
    syncKindSwitchHrefs(pageUrl);
    if (abortController) abortController.abort();
    abortController = new AbortController();

    setLoading(true);

    return fetch(sectionFetchUrl(pageUrl), { signal: abortController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed');
        return response.text();
      })
      .then(function (html) {
        applySectionHtml(html, openDetailsId);

        var next = new URL(pageUrl, window.location.origin);
        var searchParams = next.search ? next.search.slice(1) : '';
        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.searchParamsPrev = searchParams;
        }
        history.pushState({ searchParams: searchParams, acPathFilter: true }, '', next.pathname + next.search);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        setLoading(false);
        window.location.assign(pageUrl);
      });
  }

  function handleInput(event) {
    var input = event.target;
    if (!isPathFilterInput(input)) return;

    var url = input.getAttribute('data-collection-filter-url');
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Collection/mood facet: radio behavior — uncheck siblings when selecting
    if (input.name === 'filter.collection' && input.checked) {
      var scope = input.closest('details.js-filter') || input.closest('form') || document;
      scope.querySelectorAll('input[name="filter.collection"][data-collection-filter-url]').forEach(function (other) {
        if (other !== input) other.checked = false;
      });
    }

    var details = input.closest('details.js-filter');
    var openDetailsId = details && details.id ? details.id : null;
    if (details) details.setAttribute('open', '');

    // Optimistic status update (checkbox already toggled by the browser)
    refreshFacetStatus();
    loadPathFilter(url, openDetailsId);
  }

  function handleClearClick(event) {
    var link = event.target.closest('[data-collection-filter-clear]');
    if (!link) return;

    var url = preserveProductKind(link.getAttribute('href'));
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var openDetails = document.querySelector('details.js-filter[open]');
    var openDetailsId = openDetails && openDetails.id ? openDetails.id : null;

    var fromMoreTooltip = !!(
      link.closest('.active-facets__more-tooltip') ||
      (portaledTooltip && portaledTooltip.contains(link))
    );

    if (fromMoreTooltip) {
      clearTimeout(moreCloseTimer);
      moreCloseTimer = null;
      reopenMoreTooltipAfterSync = true;
      var tip =
        link.closest('.active-facets__more-tooltip') ||
        portaledTooltip;
      reopenMoreTooltipId = (tip && tip.id) || '';
      // Keep the open chip visually locked while the section reloads
      if (portaledTrigger) {
        portaledTrigger.classList.add('is-open');
        portaledTrigger.setAttribute('aria-expanded', 'true');
      }
    } else {
      // Optimistic empty only when clearing outside the overflow tooltip
      var root = document.querySelector('[data-ac-active-facets]');
      if (root && link.classList.contains('active-facets__button-remove')) {
        root.classList.add('active-facets--empty');
        var status = root.querySelector('[data-ac-facet-status]');
        if (status) {
          status.textContent = status.getAttribute('data-label-all') || 'Showing all products';
        }
      }
    }

    loadPathFilter(url, openDetailsId);
  }

  document.addEventListener('change', handleInput, true);
  document.addEventListener(
    'input',
    function (event) {
      if (!isPathFilterInput(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {
      if (isPathFilterInput(event.target)) {
        event.stopImmediatePropagation();
        return;
      }

      // Portaled tooltip lives on document.body — handle before generic outside-close
      if (portaledTooltip && portaledTooltip.contains(event.target)) {
        if (event.target.closest('[data-collection-filter-clear]')) {
          handleClearClick(event);
        }
        return;
      }

      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        // Allow clicks on clear links inside the in-place tooltip
        if (event.target.closest('[data-collection-filter-clear]')) {
          handleClearClick(event);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleMoreTooltip(more);
        return;
      }

      closeAllMoreTooltips();
      handleClearClick(event);
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      lastPointer.x = event.clientX;
      lastPointer.y = event.clientY;
      var open = document.querySelector('[data-active-facets-more].is-open');
      if (!open) return;
      if (isPointerOverMore(open)) {
        clearTimeout(moreCloseTimer);
        moreCloseTimer = null;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      if (!canHoverOpenMore()) return;
      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        openMoreTooltip(more);
        return;
      }
      if (portaledTooltip && portaledTrigger && portaledTooltip.contains(event.target)) {
        openMoreTooltip(portaledTrigger);
      }
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      if (!canHoverOpenMore()) return;
      var next = event.relatedTarget;
      var more = event.target.closest('[data-active-facets-more]');
      if (more) {
        if (next && (more.contains(next) || (portaledTooltip && portaledTooltip.contains(next)))) return;
        scheduleCloseMoreTooltip(more);
        return;
      }
      if (portaledTooltip && portaledTrigger && portaledTooltip.contains(event.target)) {
        if (next && (portaledTooltip.contains(next) || portaledTrigger.contains(next))) return;
        scheduleCloseMoreTooltip(portaledTrigger);
      }
    },
    true
  );

  document.addEventListener(
    'scroll',
    function () {
      if (portaledTooltip && portaledTrigger) positionPortaledTooltip(portaledTrigger, portaledTooltip);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var more = event.target.closest && event.target.closest('[data-active-facets-more]');
    if (!more) {
      if (event.key === 'Escape') closeAllMoreTooltips();
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleMoreTooltip(more);
    } else if (event.key === 'Escape') {
      closeAllMoreTooltips();
      more.focus();
    }
  });

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.acPathFilter) return;
    var openDetails = document.querySelector('details.js-filter[open]');
    var openDetailsId = openDetails && openDetails.id ? openDetails.id : null;
    loadPathFilter(window.location.pathname + window.location.search, openDetailsId);
  });

  // Expose for facets.js / other section re-renders
  window.acRefreshFacetStatus = refreshFacetStatus;
  function onReady() {
    refreshFacetStatus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
